import MarketEmploymentInfoCard from './MarketEmploymentInfoCardContainer';

export default MarketEmploymentInfoCard;
